import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import BlogDetails from "./pages/blog/BlogDetails";
import SolarElectricalInstallation from "./pages/services/SolarElectricalInstallation";
import OnGridOffGridSolar from "./pages/services/OnGridOffGridSolar";
import HybridSolarPowerPlant from "./pages/services/HybridSolarPowerPlant";
import EVChargingSolution from "./pages/services/EVChargingSolution";
import SolarWaterPumpSolution from "./pages/services/SolarWaterPumpSolution";
import SolarWaterHeaterSolution from "./pages/services/SolarWaterHeaterSolution";
import EnergyEfficientBuilding from "./pages/services/EnergyEfficientBuilding";
import About from "./pages/about/About";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog-details" element={<BlogDetails />} />
            {/* Our Services */}
            <Route path="/solar-electrical-installation" element={<SolarElectricalInstallation />} />
            <Route path="/on-grid-off-grid-solar" element={<OnGridOffGridSolar />} />
            <Route path="/hybrid-solar-power-plant" element={<HybridSolarPowerPlant />} />
            <Route path="/EV-charging-solution" element={<EVChargingSolution />} />
            <Route path="/solar-water-pump-solution" element={<SolarWaterPumpSolution />} />
            <Route path="/solar-water-heater-solution" element={<SolarWaterHeaterSolution />} />
            <Route path="/energy-efficient-building" element={<EnergyEfficientBuilding />} />
            <Route path="/about" element={<About />} />



          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
